module.exports = __webpack_public_path__ + "static/media/aperol.6fbc2cdf.png";